import SpeechTopicsList from "./tabs/SpeechTopics/List";
import ParagraphsList from "./tabs/Paragraphs/List";
import SentencesList from "./tabs/Sentences/List";

export const STIMULUS_SUB_TABS = [
  { label: 'Speech Topics', key: 'topicInfos', component: SpeechTopicsList },
  { label: 'Paragraphs', key: 'paragraphs', component: ParagraphsList },
  { label: 'Sentences', key: 'sentences', component: SentencesList },
  // Future: add more sub-tabs here
];

